module.exports = __webpack_public_path__ + "assets/icon-conductor-horseWire.7443285d.svg";